import React from "react";
import "./autoScroll.css";
import img1 from '../../assets/icn1.jpg';
import img2 from '../../assets/icn2.png';
import img3 from '../../assets/moqadas.png';
import img4 from '../../assets/pronton.jpg';
import img5 from '../../assets/cdsr.png';


const AutoScrollSlider = () => {
   const images = [
     img1,
     img2,
     img3,
     img4,
     img5,
     img1,
     img2,
     img3,
     img4,
     img5,
     img1,
     img2,
     img3,
     img4,
     img5,
     img1,
     img2,
     img3,
     img4,
   ];
  return (
    <div className="slider">
      <div className="slide-track">
        {images.map((src, index) => (
          <div className="slide" key={index}>
            <img src={src} alt={`Brand Logo ${index + 1}`} width="100" height="100" />
          </div>
        ))}
      </div>
    </div>
  );
};

export default AutoScrollSlider;
